import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossClient } from '../components/views/militaryHearingLossView/MilitaryHearingLossClient/MilitaryHearingLossClient'

function MilitaryHearingLossClientPage() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Client Record" />
                    <MilitaryHearingLossClient />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossClientPage
